import React from 'react';
import './header.scss';

class Header extends React.Component {
	constructor(props){
		super(props);
		this.state = {
		};
	}

	render (){
		return (
			<div id="header">
				<div className="header">
					<h1>夜空のコリー</h1>
					<div className="menu">
						<button
							onClick={()=>this.back()}
						><i className="fas fa-door-open fa-fw"></i></button>
						<button
							onClick={()=>this.props.openBook()}
						><i className="fas fa-book fa-fw"></i></button>
					</div>
				</div>
			</div>
		)
	}

	back (){
		//this.props.clearMessage();
		//this.props.addMessage("途中終了してよろしいですか？");
		//this.props.showConfirm( ()=>{
			//this.props.setState({mode:"top"});
		//} );
		this.props.goTop();
	}
}

export default Header;